import { render, staticRenderFns } from "./BillList.vue?vue&type=template&id=96ac6280&"
import script from "./BillList.vue?vue&type=script&lang=js&"
export * from "./BillList.vue?vue&type=script&lang=js&"
import style0 from "./BillList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports